import { getFileData, getFileMetadata } from "../utility/storage";
import { apiRequest, postPython } from "../api/ApiCall";
import { LOCAL_CONSTANT } from "./Const";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setObjAppHeader } from "../features/appHeaderSlice";
import { getLongPageData } from "../data/DataManage";

// トークン取得
export const getAccessToken = () => {
    let access_token = "?access_token=";
    const objectJSON = sessionStorage.getItem("token");
    if (objectJSON) {
        access_token = "?access_token=" + JSON.parse(objectJSON) + "";
    }

    return access_token;
};

// スタッフ名取得
export const staffName = (code: string) => {
    let name = "";
    const res: any = localStorage.getItem("staffMaster");
    if (res) {
        // const d = JSON.parse(res)
        JSON.parse(res)?.map((row: any) => {
            if (row.staff_number === code) {
                name = row.staff_name;
            }
        });
    }

    return name;
};

export const setSelecterDisplay = (codeMaster: any, code_value: string) => {
    let code_display = "";
    if (codeMaster && code_value !== "" && code_value !== undefined) {
        codeMaster.filter((row: any) => {
            if (row.code_value === code_value.toString()) {
                code_display = row.code_display;
            }
        });
    }
    return code_display;
};

export const setSelecterValue = (codeMaster: any, code_display: string) => {
    let code_value = "";
    if (codeMaster && code_display !== "" && code_display !== undefined) {
        codeMaster.filter((row: any) => {
            if (row.code_display === code_display.toString()) {
                code_value = row.code_value;
            }
        });
    }
    return code_value;
};

/**
 * ダウンロードファイル名指定でファイルダウンロード
 * @param filePath ダウンロードパス
 * @param fileName ファイル名
 */
export const commonFileDownload = (filePath: string, fileName: string) => {
    (async () => {
        try {
            const url = await getFileData(filePath);
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = (event) => {
                const blob = xhr.response;
                const link = document.createElement("a");
                document.body.appendChild(link);
                link.download = fileName;
                link.href = window.URL.createObjectURL(blob);
                link.click();
                document.body.removeChild(link);
            };
            xhr.open("GET", url as string);
            xhr.send();
        } catch (e) {
            console.log(e);
        }
    })();
};

/**
 * アップロードファイル名でファイルダウンロード
 * @param filePath ダウンロードパス
 */
export const commonFileDownloadFileName = (filePath: string) => {
    (async () => {
        try {
            getFileMetadata(filePath).then((metaData: any) => {
                getFileData(filePath).then((url: any) => {
                    const xhr = new XMLHttpRequest();
                    xhr.responseType = "blob";
                    xhr.onload = (event) => {
                        const blob = xhr.response;
                        const link = document.createElement("a");
                        document.body.appendChild(link);
                        link.download = metaData.name;
                        link.href = window.URL.createObjectURL(blob);
                        link.click();
                        document.body.removeChild(link);
                    };
                    xhr.open("GET", url as string);
                    xhr.send();
                });
            });
        } catch (e) {
            console.log(e);
        }
    })();
};

/**
 * 各パラメータに対してのAPIリクエストを実行
 * @param params APIに送るパラメータのリスト
 */
export const updateListRegist = (params: any) => {
    return new Promise((resolve, reject) => {
        params.map((param: any) => {
            (async () => {
                try {
                    await apiRequest(param);
                    resolve(true);
                } catch (e) {
                    console.log(e);
                    reject();
                }
            })();
        });
    });
};

/**
 * ファイル拡張子チェック
 * 
 * 指定されたファイルの拡張子が許可されているかをチェックし、エラーの場合は自動的にエラーモーダルを表示する
 * @param file チェック対象ファイル
 * @param allowedExtensions 許可する拡張子配列（例: [".xlsx", ".pdf"]）
 * @param setMessageDialogOpen モーダル開閉状態を設定する関数
 * @param setMessage エラーメッセージを設定する関数
 * @param setHasButton モーダルのボタン表示状態を設定する関数
 * @param errorMessage 表示するエラーメッセージ
 * @returns チェック結果（true: 拡張子が許可されている, false: 拡張子エラー）
 * 
 * @example
 * // Excelファイルのチェック例
 * const isValid = fileExtensionCheck(
 *   file, 
 *   LOCAL_CONSTANT.FILE_EXTENSIONS.EXCEL, 
 *   setMessageDialogOpen, 
 *   setMessage, 
 *   setHasButton,
 *   LOCAL_CONSTANT.CONFIRM_MESSAGE.EXTENSION_CHECK_EXCEL
 * );
 */
export const fileExtensionCheck = (
    file: File, 
    allowedExtensions: string[],
    setMessageDialogOpen: (open: boolean) => void,
    setMessage: (message: string) => void,
    setHasButton: (hasButton: boolean) => void,
    errorMessage: string
): boolean => {
    // ファイル名から拡張子を取得（小文字に変換）
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    
    // 許可された拡張子リストに含まれているかチェック
    if (!allowedExtensions.includes(fileExtension)) {
        // エラーの場合、モーダルを表示
        setMessageDialogOpen(true);
        setMessage(errorMessage);
        setHasButton(true);
        return false;
    }
    
    // 拡張子が許可されている場合
    return true;
};

//テーブル名の論理名をセット
export const setTableLogicName = (table_physics_name: string) => {
    const tableNameMasterObj = localStorage.getItem("tableNameMaster");
    let table_logic_name = table_physics_name;
    if (tableNameMasterObj) {
        const jsonObj = JSON.parse(tableNameMasterObj);
        jsonObj.some((row: any) => {
            if (row.table_physics_name === table_physics_name) {
                table_logic_name = row.table_logic_name;
                return true; // 条件を満たしたのでループを終了
            } else {
                return false;
            }
        });
    }
    return table_logic_name;
};

//テーブル名の物理名をセット
export const setTablePhysicsName = (table_logic_name: string) => {
    const tableNameMasterObj = localStorage.getItem("tableNameMaster");
    let table_physics_name = table_logic_name;
    if (tableNameMasterObj) {
        const jsonObj = JSON.parse(tableNameMasterObj);
        jsonObj.some((row: any) => {
            if (row.table_logic_name === table_logic_name) {
                table_physics_name = row.table_physics_name;
                return true; // 条件を満たしたのでループを終了
            } else {
                return false;
            }
        });
    }
    return table_physics_name;
};

//テーブル項目名の論理名をセット
export const setColumnLogicName = (table_physics_name: string, column_physics_name: string) => {
    const tableNameMasterObj = localStorage.getItem("tableNameMaster");
    let column_logic_name = column_physics_name;
    if (tableNameMasterObj) {
        const jsonObj = JSON.parse(tableNameMasterObj);
        jsonObj.some((row: any) => {
            if (
                row.table_physics_name === table_physics_name &&
                row.column_physics_name === column_physics_name
            ) {
                column_logic_name = row.column_logic_name;
                return true; // 条件を満たしたのでループを終了
            } else {
                return false;
            }
        });
    }
    return column_logic_name;
};

//ページとテーブル名紐づけ
export const pageToTableMapFunc = (pageName: string) => {
    let pageToTableMap = "";
    switch (pageName) {
        // 追加資料ページはテーブル名をlocation_baseに合わせる
        case LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH:
            pageToTableMap = LOCAL_CONSTANT.TABLE.BASE;
            break;
        // その他資料ページはテーブル名をlocation_baseに合わせる
        case LOCAL_CONSTANT.NAVI.OTHER_DOCUMENT:
            pageToTableMap = LOCAL_CONSTANT.TABLE.BASE;
            break;
        // 表紙ページはテーブル名をlocation_coverに合わせる
        case LOCAL_CONSTANT.NAVI.COVER:
            pageToTableMap = LOCAL_CONSTANT.TABLE.COVER;
            break;
        // 競合ページはテーブル名をlocation_conflictに合わせる
        case LOCAL_CONSTANT.NAVI.CONFLICT:
            pageToTableMap = LOCAL_CONSTANT.TABLE.CONFLICT;
            break;
        // 競合ページの商圏カット根拠はテーブル名をlocation_conflict_market_cutに合わせる
        case LOCAL_CONSTANT.NAVI.TRADE_AREA_CUT:
            pageToTableMap = LOCAL_CONSTANT.TABLE.CONFLICT_MARKET_CUT;
            break;
        default:
            pageToTableMap = pageName;
            break;
    }
    return pageToTableMap;
};


// 候補地情報取得
export const getPlanAreaInfo = (planAreaId: string | null, objStorePlanAreaId: string) => {
    let searchPlanAreaId = planAreaId;
    let planAreaInfoJSON = ""
    if (planAreaId !== null) {
        if (planAreaId.startsWith("X") || planAreaId.startsWith("Y")) {
            searchPlanAreaId = objStorePlanAreaId;
        }
    }
    const params = {
        mode: "regist",
        endPoint: "/sfdc/planArea/v1/info",
        query: {
            plan_area_id: searchPlanAreaId,
        },
    };
    return new Promise(resolve => {
        (async () => {
            try {
                const apiPlanAreaInfo = await apiRequest(params);
                if (apiPlanAreaInfo.data.dataList.length > 0) {
                    planAreaInfoJSON = JSON.parse(apiPlanAreaInfo.data.dataList[0]);
                    resolve(planAreaInfoJSON)
                }
            } catch (e) {
                console.log(e);
            }
        })();
    })

};

/**
 * planAreaSearchByIdのAPIパラメータを構築する共通関数
 * ユーザー権限に基づいて適切なパラメータを生成する
 * @param planAreaId 候補地ID
 * @param userData ユーザーデータ（JSON文字列）
 * @param objStorePlanAreaId
 * @returns planAreaSearchByIdのAPIパラメータ
 */
export const createPlanAreaSearchByIdParam = (
    planAreaId: string,
    userData: string,
    objStorePlanAreaId: string = ""
): any => {
    let searchPlanAreaId = planAreaId;
    
    // ユーザーデータをパース
    const jsonUserData = JSON.parse(userData);
    
    // 管理都市フラグの設定（管理者または全都市管理の場合はfalse）
    let manageCitiesFlg = true;
    if (
        jsonUserData.administrator_flag === "1" ||
        jsonUserData.manage_cities?.includes("ALL")
    ) {
        manageCitiesFlg = false;
    }
    
    // 管理ステップの設定
    const manage_steps = ["0", "99"];
    // 複製店舗は既存店のためSTEP8は対象外
    if (
        planAreaId &&
        !planAreaId.startsWith("X") &&
        !planAreaId.startsWith("Y")
    ) {
        manage_steps.push("8");
    }
    
    // ステップカウントの計算
    let stepCnt = jsonUserData.manage_steps.filter(
        (val: any) => manage_steps.includes(val) === false
    );
    
    // 管理都市外プランの設定
    let managePlansOutsideCities = jsonUserData.manage_plans_outside_cities;
    if (!managePlansOutsideCities.includes("")) {
        managePlansOutsideCities.push("");
    }
    
    // 複製店舗の場合は検索対象IDを変更
    if (
        planAreaId &&
        (planAreaId.startsWith("X") || planAreaId.startsWith("Y")) &&
        objStorePlanAreaId
    ) {
        searchPlanAreaId = objStorePlanAreaId;
    }
    
    // APIパラメータを返す
    return {
        mode: "planAreaSearchById",
        id: searchPlanAreaId,
        manageCitiesFlg: manageCitiesFlg,
        manageCities: jsonUserData.manage_cities.join(","),
        manageStep: stepCnt.join(","),
        managePlansOutsideCities: managePlansOutsideCities.join(","),
    };
};

/**
 * ヘッダー表示用のplanAreaSearchById呼び出しカスタムHook
 * 候補地情報を取得してRedux storeに設定する
 * ItemChangeHistory、EvaluateChangeHistoryで使用
 * @returns planAreaId と userData のみを引数とする関数
 */
export const usePlanAreaSearchByIdForHeader = () => {
    const dispatch = useAppDispatch();
    const objAppHeader = useAppSelector((state) => state.appHeader);
    
    return async (planAreaId: string, userData: string): Promise<void> => {
        // 入力値チェック
        if (!userData || planAreaId === "") return;
        
        try {
            // パラメータ作成
            const param = createPlanAreaSearchByIdParam(planAreaId, userData);
            
            // API呼び出し
            const res: any = await getLongPageData([param]);
            
            // レスポンスチェックとRedux更新
            if (res.planAreaSearchById && res.planAreaSearchById.length > 0) {
                dispatch(
                    setObjAppHeader({
                        ...objAppHeader,
                        planAreaId: res.planAreaSearchById[0].id,
                        planAreaName: res.planAreaSearchById[0].plan_area_name,
                        citycode: res.planAreaSearchById[0].citycode,
                        centerlat: res.planAreaSearchById[0].centerlat,
                        centerlon: res.planAreaSearchById[0].centerlon,
                    })
                );
            }
        } catch (e) {
            console.log("planAreaSearchById API呼び出しエラー:", e);
        }
    };
};
